import { render } from "./ButtonPreloader.vue?vue&type=template&id=dd398bc2"
import script from "./ButtonPreloader.vue?vue&type=script&lang=js"
export * from "./ButtonPreloader.vue?vue&type=script&lang=js"

import "./ButtonPreloader.vue?vue&type=style&index=0&id=dd398bc2&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__